var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.exam.is_in_grace_period)?_c('section',{staticClass:"container is-full is-greyish align-vertical is-centered pb-5"},[_vm._m(0),_vm._v(" "),_c('h1',{staticClass:"text-is-blue huge-title",domProps:{"innerHTML":_vm._s(_vm.$t('exam.please-wait-for-next-attempt'))}}),_vm._v(" "),_c('div',{staticClass:"subtitle is-4"},[_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('exam.in-the-meantime-revise-chapters', {
          url: '/course/'+_vm.exam.course_id,
        })
      )}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('exam.next-attempt-wait-text', {
          time_left: _vm.exam.previousAttempt.time_till_next_attempt,
        })
      )}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(
        _vm.$t('exam.last-attempt-results', {
          results: _vm.exam.previousAttempt.result,
          pass_rate: _vm.exam.pass_rate,
        })
      )}})])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"title huge-title mt-1 opacity-6"},[_c('i',{staticClass:"fa fa-clock-o fa-3x"})])
}]

export { render, staticRenderFns }